import React, { useState } from "react";

import { Transaction_Payment } from "../../Connections/Transaction";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import Toast from "../../Utils/Toast";

import "../../Styles/Rechargewallet.css";

const RechargewalletCart = ({ close, walletBalance, prevPath }) => {
  const [moneyvalue, setMoneyvalue] = useState();
  const [loading, setLoading] = useState(false);

  //======================================================
  const handleSubmitRechargeForm = (e) => {
    e.preventDefault();
    if (moneyvalue) {
      setLoading(true);
      const domainname = window.location.hostname;
      const protocol = window.location.protocol;
      const url = `${protocol}//${domainname}${prevPath}`;
      const Formdata = new FormData();
      Formdata.append("Url", url);
      Formdata.append("ChargePrice", `${moneyvalue}`);
      Formdata.append("PaymentType", 3);
      Transaction_Payment.PaymentRequest(Formdata)
        .then((res) => {
          if (res[0]) {
            window.location.href = res[2].data.url;
          } else {
            Toast("error", "مشکلی پیش آمده است");
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } else {
      Toast("error", "اول مبلغ رو وارد کن.");
    }
  };
  //======================================================

  return (
    <div className="wallet-wrapper">
      <div className="Recharg">
        <form onSubmit={handleSubmitRechargeForm} className="Recharg-inside">
          <div className="Recharg-inside-item1">
            <div className="Recharg-inside-item1-text">
              <p className="Recharg-inside-item1-text-p">شارژ کیف پول</p>
            </div>

            <div className="Recharg-inside-item1-image" onClick={close}>
              <img
                className="Recharg-inside-item1-image-img"
                src="imgs/Profile/Icon.svg"
              />
            </div>
          </div>
          <div className="Recharg-inside-item2">
            <div className="Recharg-inside-item2-image1">
              <img
                className="Recharg-inside-item2-image1-img"
                src="imgs/Profile/Rechargewallet.svg"
              />
            </div>
          </div>
          <div className="Recharg-inside-item3">
            <div className="Recharg-inside-item3-inside">
              <div className="Recharg-inside-item3-inside-right">
                <p className="Recharg-inside-item3-inside-right-text">
                  موجودی کیف پول شما
                </p>
              </div>
              <div className="Recharg-inside-item3-inside-left">
                <p className="Recharg-inside-item3-inside-left-text">
                  <span className="Recharg-inside-item3-inside-left-Money number-font">
                    {walletBalance}
                  </span>
                  تومان
                </p>
              </div>
            </div>
          </div>
          <div className="Recharg-inside-item4">
            <div className="Recharg-inside-item4-inside">
              <div className="Recharg-inside-item4-inside-top">
                <p className="Recharg-inside-item4-inside-top-text">
                  مبلغ دلخواه خودت رو وارد کن
                </p>
              </div>
              <div className="Recharg-inside-item4-inside-bottom">
                <input
                  className="Recharg-inside-item4-inside-bottom-input input-Money"
                  type="number"
                  required
                  id="money"
                  value={moneyvalue}
                  onInvalid={(e) => {
                    e.preventDefault();
                    Toast("error", "لطفا مبلغ را وارد کنید.");
                  }}
                  onChange={(e) => setMoneyvalue(e.target.value)}
                />
                <label
                  htmlFor="money"
                  className="Recharg-inside-item4-inside-bottom-label"
                >
                  مبلغ دلخواه
                </label>
                <p className="Recharg-inside-item4-inside-bottom-text">تومان</p>
              </div>
            </div>
          </div>
          <div className="Recharg-inside-item5">
            <div className="Recharg-inside-item5-top">
              <p className="Recharg-inside-item5-top-text">
                یا مبلغ پیشنهادی رو انتخاب کن
              </p>
            </div>
            <div className="Recharg-inside-item5-bottom">
              <div className="Recharg-inside-item5-bottom-inside">
                <div className="Recharg-inside-item5-bottom-inside-top">
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(10000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        10,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(20000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        20,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(30000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        30,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                </div>

                <div className="Recharg-inside-item5-bottom-inside-bottom">
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(50000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        50,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(100000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        100,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                  <div
                    className="Recharg-inside-item5-bottom-inside-box"
                    onClick={() => {
                      setMoneyvalue(200000);
                    }}
                  >
                    <div className="Recharg-inside-item5-bottom-inside-box-inside">
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-Money number-font">
                        200,000
                      </p>
                      <p className="Recharg-inside-item5-bottom-inside-box-inside-text">
                        تومان
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Recharg-inside-item6">
            <button className="Recharg-inside-item6-button" type="submit">
              {loading ? <LoadingSpinner /> : "پرداخت"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

RechargewalletCart.defaultProps = {
  prevPath: "/cart",
};

export default RechargewalletCart;
